export const paramMap = new Map([
  ['login', { paramType: 'login', defaultContent: 'ssp.help.default.login' }],
  ['login/sso', { paramType: 'login', defaultContent: 'ssp.help.default.login' }],
]);
